const copyUrlToClipboard = async () => {
    try {
        await navigator.clipboard.writeText(location.href);
    } catch (err) {
        console.error("Failed to copy: ", err);
    }
};

// Shared transient status message. Renders into the single #agent-toast
// element a page may carry; silently no-ops when that element is absent.
let toastTimer = null;
const showToast = (message) => {
    const toastEl = document.getElementById("agent-toast");
    if (!toastEl) {
        return;
    }
    toastEl.textContent = message;
    toastEl.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove("show"), 1600);
};

export { copyUrlToClipboard, showToast };
